import { ReactNode, useState } from "react";
import { ScrollView, View, XStack } from "tamagui";

import { Sidebar } from "./Sidebar";

interface LayoutProps {
  noPadding?: boolean;
  children: ReactNode;
}

const Layout = ({ noPadding, children }: LayoutProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <XStack flex={1} height="100vh">
      <Sidebar isOpen={isSidebarOpen} onOpenChange={setIsSidebarOpen} />
      <ScrollView
        flex={1}
        minHeight="100%"
        backgroundColor="$gray1"
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          flexGrow: 1,
          ...(!noPadding && {
            paddingVertical: "$8",
            paddingHorizontal: "$5",
          }),
        }}
      >
        <View width="100%" maxWidth={1200} alignSelf="center" flexGrow={1}>
          {children}
        </View>
      </ScrollView>
    </XStack>
  );
};

export default Layout;
